<template>
  <div>
     <!-- <AssociateSidebar /> -->
      <div class="sidebar-layout">
      <div class="sidebar-nav" :class="{ showSidebar: mobileShow }">
        <div class="nav-container">
          <div class="logo-image">
            <!-- <router-link to="/">
              <img width="100" src="@/assets/images/smart_logo_white.png" alt="smart realtor logo" />
            </router-link> -->
            <!-- <router-link to="/"> -->
              <!-- <img width="100" src="@/assets/images/smart_logo_white.png" alt="smart realtor logo" /> -->
              <div class="d-flex">
               <router-link to="/">
                 <img width="100" src="@/assets/images/smart-logo-new.svg" alt="smart realtor logo" />
               </router-link>
                <div>
                  <select id="smartType" class="form-control type-select" v-model="userTypeSelect">
                    <option selected value="partner" v-if="userPlans == '4' || userPlans == '5'">Partner</option>
                    <option value="associate">Associate</option>
                    <option value="vendor">Vendor</option>
                    <option value="agent">Agent</option>
                    <!-- <option value="vendor" v-if="userPlans == '1'">Vendor</option>
                    <option value="agent" v-if="userPlans == '2'">Agent</option> -->
                  </select>
                </div>
              </div>
            <!-- </router-link> -->
            <button class="mobile-close-sidebar" @click="mobileShow = false">
              x
            </button>
          </div>
          <hr>
          <!-- <div class="nav-top-verified">
            <span class="verified-active" v-if="user.verified == '1' && subscription == 'YES'">VERIFIED</span>
            <span class="verified-active" v-if="user.verified == '0' && subscription == 'YES'">Active</span>
            <div class="subscribe-toggle">
              <p class="subscribed" v-if="subscription === 'YES'">Subscribed</p>
              <p class="notsubscribed" v-else>Not Subscribed</p>
            </div>
          </div> -->
          <div class="nav-items">
            <!-- <div class="nav-top-verified"> -->
              <span class="verified-active" v-if="user.verified == '1' && subscription == 'YES'">VERIFIED</span>
              <span class="verified-active" v-if="user.verified == '0' && subscription == 'YES'">Active</span>
              <div class="subscribe-toggle">
                <p class="subscribed" v-if="subscription === 'YES'">Subscribed</p>
                <p class="notsubscribed" v-else>Not Subscribed</p>
              </div>
            <!-- </div> -->
            
            <!-- <AssociateSidebarLinks class="d-none" v-if="userTypeSelect === 'associate'"></AssociateSidebarLinks> -->
            <div class="nav">
              <ul class="nav-list">

                <li v-if="checkUser.show_partner_button == 'YES' && userTypeSelect === 'partner'">
                  <router-link to="/user/partner/dashboard" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="18" viewBox="0 0 21 18" fill="none">
                        <path class="primary-fill"
                          d="M19.9898 2.78509C19.5476 1.38109 16.2567 0 10.5 0C4.74337 0 1.4521 1.38109 1.01034 2.78509C0.978263 2.8332 0.95459 2.88589 0.95459 2.94545V3.10909V6.87273V7.03636V7.2V10.8V10.9636V11.1273V15.0545C0.95459 15.1076 0.971008 15.1576 0.999263 15.2021C1.45019 16.8041 5.48448 18 10.5 18C15.5042 18 19.532 16.8091 19.9978 15.2129C20.0283 15.1661 20.0455 15.1121 20.0455 15.0545V11.1273V10.9636V10.8V7.2V7.03636V6.87273V3.10909V2.94545C20.0455 2.88589 20.0218 2.8332 19.9898 2.78509ZM19.2517 11.1224C19.241 11.162 19.2261 11.2012 19.2074 11.2412C19.1921 11.2736 19.1734 11.306 19.1528 11.3384C19.1272 11.3786 19.0986 11.4189 19.0646 11.4591C19.0394 11.4896 19.0108 11.5197 18.981 11.5498C18.9386 11.5927 18.8936 11.6355 18.8424 11.6781C18.8115 11.7039 18.7775 11.7295 18.7431 11.7553C18.6805 11.8021 18.6152 11.8486 18.5423 11.8947C18.511 11.9147 18.4774 11.934 18.4442 11.9536C18.3579 12.0047 18.2678 12.0554 18.1689 12.1052C18.1429 12.1186 18.115 12.1313 18.0879 12.1444C17.9741 12.1994 17.8554 12.2541 17.7271 12.3071C17.7107 12.314 17.6935 12.3205 17.6767 12.3271C17.5335 12.385 17.3838 12.4419 17.2239 12.4969C17.2193 12.4985 17.2147 12.4999 17.2101 12.5015C16.343 12.7983 15.2338 13.048 13.9414 13.2117C13.9349 13.2123 13.9284 13.213 13.9219 13.214C13.6707 13.2457 13.4129 13.2739 13.1483 13.2987C13.1052 13.3027 13.0598 13.3053 13.0162 13.3092C12.7852 13.3298 12.5516 13.3488 12.311 13.3639C12.201 13.3707 12.0857 13.374 11.9739 13.3799C11.7929 13.3891 11.6138 13.3992 11.4282 13.4048C11.1251 13.4129 10.8158 13.4182 10.5 13.4182C10.1843 13.4182 9.87501 13.4129 9.57146 13.4038C9.3859 13.3982 9.20683 13.3877 9.02584 13.3789C8.91397 13.3733 8.79866 13.3697 8.6887 13.3629C8.44815 13.3478 8.21448 13.3288 7.98348 13.3082C7.93995 13.3043 7.89452 13.3017 7.85137 13.2977C7.58677 13.2729 7.32904 13.2444 7.07781 13.213C7.07132 13.2123 7.06483 13.2117 7.05834 13.2107C5.76588 13.0471 4.6567 12.7973 3.78959 12.5005C3.78501 12.4992 3.78043 12.4976 3.77584 12.4959C3.61586 12.4409 3.46581 12.384 3.32301 12.3261C3.30659 12.3192 3.28903 12.3127 3.27261 12.3061C3.14432 12.2531 3.02557 12.1988 2.91179 12.1435C2.88506 12.1304 2.85681 12.1176 2.83084 12.1042C2.73195 12.0544 2.64184 12.0037 2.55555 11.9527C2.52272 11.933 2.48874 11.9137 2.45743 11.8937C2.3845 11.8476 2.31921 11.8011 2.25659 11.7543C2.22261 11.7288 2.18824 11.7033 2.15732 11.6771C2.10615 11.6345 2.0611 11.592 2.01872 11.5488C1.98894 11.5187 1.9603 11.4886 1.9351 11.4581C1.9015 11.4179 1.87286 11.3776 1.8469 11.3374C1.82628 11.305 1.80795 11.2726 1.7923 11.2402C1.77359 11.2006 1.7587 11.161 1.74801 11.1214C1.73388 11.0693 1.71823 11.0163 1.71823 10.9636C1.71823 10.9267 1.72319 10.8897 1.73006 10.853C1.73961 10.8036 1.73426 10.7542 1.71823 10.7074V8.27771C1.72892 8.28622 1.74228 8.2944 1.75335 8.30291C1.83659 8.36575 1.92135 8.42825 2.01681 8.48847C3.45512 9.42087 6.33135 10.1455 10.5 10.1455C14.6512 10.1455 17.5202 9.42676 18.9646 8.49993C19.0799 8.42793 19.1837 8.35364 19.2815 8.27804L19.2819 8.27771V10.7074C19.2658 10.7542 19.2605 10.8036 19.27 10.853C19.2773 10.8897 19.2819 10.9267 19.2819 10.9636C19.2819 11.0163 19.2662 11.0693 19.2517 11.1224ZM19.2819 4.35044V6.78011C19.2658 6.82691 19.2605 6.87633 19.27 6.92575C19.2773 6.9624 19.2819 6.99938 19.2819 7.03636C19.2819 7.08905 19.2662 7.14207 19.2517 7.19509C19.241 7.23469 19.2261 7.27396 19.2074 7.31389C19.1921 7.34629 19.1734 7.37869 19.1528 7.41109C19.1272 7.45135 19.0986 7.4916 19.0646 7.53185C19.0394 7.56229 19.0108 7.5924 18.981 7.62251C18.9386 7.66538 18.8936 7.70825 18.8424 7.7508C18.8115 7.77665 18.7775 7.80218 18.7431 7.82804C18.6805 7.87484 18.6152 7.92131 18.5423 7.96745C18.511 7.98742 18.4774 8.00673 18.4442 8.02636C18.3579 8.07742 18.2678 8.12815 18.1689 8.17789C18.1429 8.19131 18.115 8.20407 18.0879 8.21716C17.9741 8.27215 17.8554 8.3268 17.7271 8.37982C17.7107 8.38669 17.6935 8.39324 17.6767 8.39978C17.5335 8.45771 17.3838 8.51465 17.2239 8.56964C17.2193 8.57127 17.2147 8.57258 17.2101 8.57422C16.343 8.87105 15.2338 9.12076 13.9414 9.2844C13.9349 9.28505 13.9284 9.28571 13.9219 9.28669C13.6707 9.31844 13.4129 9.34658 13.1483 9.37145C13.1052 9.37538 13.0598 9.378 13.0162 9.38193C12.7852 9.40254 12.5516 9.42153 12.311 9.43658C12.201 9.44345 12.0857 9.44673 11.9739 9.45262C11.7929 9.46178 11.6138 9.47193 11.4282 9.47749C11.1251 9.48567 10.8158 9.49091 10.5 9.49091C10.1843 9.49091 9.87501 9.48567 9.57146 9.47651C9.3859 9.47094 9.20683 9.46047 9.02584 9.45164C8.91397 9.44607 8.79866 9.44247 8.6887 9.4356C8.44815 9.42054 8.21448 9.40156 7.98348 9.38095C7.93995 9.37702 7.89452 9.3744 7.85137 9.37047C7.58677 9.3456 7.32904 9.31713 7.07781 9.28571C7.07132 9.28505 7.06483 9.2844 7.05834 9.28342C5.76588 9.11978 4.6567 8.87007 3.78959 8.57324C3.78501 8.57193 3.78043 8.57029 3.77584 8.56865C3.61586 8.51367 3.46581 8.45673 3.32301 8.3988C3.30659 8.39193 3.28903 8.38538 3.27261 8.37884C3.14432 8.32582 3.02557 8.27149 2.91179 8.21618C2.88506 8.20309 2.85681 8.19033 2.83084 8.17691C2.73195 8.12716 2.64184 8.07644 2.55555 8.02538C2.52272 8.00574 2.48874 7.98644 2.45743 7.96647C2.3845 7.92033 2.31921 7.87385 2.25659 7.82705C2.22261 7.80153 2.18824 7.776 2.15732 7.74982C2.10615 7.70727 2.0611 7.66473 2.01872 7.62153C1.98894 7.59142 1.9603 7.56131 1.9351 7.53087C1.9015 7.49062 1.87286 7.45036 1.8469 7.41011C1.82628 7.37771 1.80795 7.34531 1.7923 7.31291C1.77359 7.27331 1.7587 7.23371 1.74801 7.19411C1.73388 7.14207 1.71823 7.08905 1.71823 7.03636C1.71823 6.99938 1.72319 6.9624 1.73006 6.92575C1.73961 6.87633 1.73426 6.82691 1.71823 6.78011V4.35044C1.76404 4.38611 1.81635 4.42113 1.86599 4.45647C1.89348 4.47611 1.91906 4.49575 1.94808 4.51538C2.06263 4.59262 2.18634 4.66887 2.32035 4.74316C2.34823 4.75855 2.37954 4.7736 2.40855 4.78898C2.52081 4.84887 2.63955 4.90745 2.76441 4.96505C2.81061 4.98633 2.85681 5.00727 2.90454 5.02822C3.0439 5.08909 3.19014 5.14833 3.34401 5.2056C3.36921 5.21509 3.39212 5.22491 3.4177 5.23407C3.59677 5.2992 3.78692 5.36138 3.9847 5.4216C4.0393 5.43829 4.09657 5.454 4.1527 5.47036C4.31001 5.51585 4.47266 5.55938 4.64104 5.6016C4.70175 5.61665 4.76132 5.63236 4.82355 5.64676C5.04692 5.69978 5.27754 5.75018 5.51961 5.79665C5.55283 5.8032 5.58872 5.80844 5.62232 5.81465C5.83575 5.85458 6.05721 5.89156 6.28477 5.92625C6.3619 5.93804 6.44017 5.94916 6.51883 5.96029C6.73532 5.99073 6.9583 6.01855 7.18701 6.04407C7.24581 6.05062 7.30194 6.05815 7.3615 6.06436C7.64557 6.09382 7.93957 6.11902 8.24159 6.14062C8.31604 6.14585 8.39355 6.14978 8.46915 6.15436C8.71084 6.16942 8.95788 6.18185 9.21064 6.19167C9.30266 6.19527 9.3943 6.19887 9.48823 6.20182C9.81735 6.21131 10.1526 6.21818 10.5 6.21818C10.8475 6.21818 11.1827 6.21131 11.5119 6.20182C11.6054 6.19887 11.697 6.19527 11.7894 6.19167C12.0422 6.18185 12.2892 6.16942 12.5309 6.15436C12.6065 6.14945 12.6837 6.14585 12.7585 6.14062C13.0605 6.11935 13.3545 6.09382 13.6386 6.06436C13.6982 6.05815 13.7543 6.05062 13.8131 6.04407C14.0418 6.01855 14.2644 5.99073 14.4813 5.96029C14.5599 5.94916 14.6382 5.93804 14.7153 5.92625C14.9429 5.89156 15.1643 5.85458 15.3778 5.81465C15.4114 5.80844 15.4473 5.80287 15.4805 5.79665C15.7226 5.75018 15.9532 5.69945 16.1765 5.64676C16.2388 5.63204 16.2983 5.61665 16.359 5.6016C16.5274 5.55938 16.6901 5.51585 16.8474 5.47036C16.9035 5.454 16.9608 5.43829 17.0154 5.4216C17.2132 5.36138 17.4037 5.2992 17.5824 5.23407C17.608 5.22491 17.6309 5.21509 17.6561 5.2056C17.81 5.148 17.9562 5.08909 18.0956 5.02822C18.1433 5.00727 18.1899 4.98633 18.2357 4.96505C18.3605 4.90778 18.4793 4.8492 18.5915 4.78898C18.6206 4.7736 18.6519 4.75855 18.6797 4.74316C18.8138 4.66887 18.9375 4.59295 19.052 4.51538C19.0806 4.49575 19.1062 4.47611 19.1341 4.45647C19.1837 4.42113 19.236 4.38611 19.2819 4.35044ZM10.5 0.654545C15.6756 0.654545 19.2819 1.94793 19.2819 3.10909C19.2819 4.27025 15.6756 5.56364 10.5 5.56364C5.3245 5.56364 1.71823 4.27025 1.71823 3.10909C1.71823 1.94793 5.3245 0.654545 10.5 0.654545ZM19.2819 14.9573C19.2765 14.9717 19.2727 14.9865 19.2696 15.0015C19.0532 16.1336 15.4774 17.3455 10.5 17.3455C5.52266 17.3455 1.94694 16.1336 1.73044 15.0015C1.72739 14.9868 1.72319 14.9724 1.71823 14.9587V12.205C1.72892 12.2135 1.74228 12.2217 1.75335 12.2302C1.83659 12.293 1.92135 12.3555 2.01681 12.4157C3.45512 13.3481 6.33135 14.0727 10.5 14.0727C14.6512 14.0727 17.5202 13.354 18.9646 12.4272C19.0799 12.3552 19.1837 12.2809 19.2815 12.2053L19.2819 12.205V14.9573Z" />
                      </svg>
                    </span>
                    <span class="text">Dashboard</span>
                  </router-link>
                </li>

                <li v-if="checkUser.show_partner_button == 'YES' && userTypeSelect === 'partner'" @click="saveClickType(1)">
                  <router-link to="/user/partner/property-management" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path class="primary-fill"
                          d="M18 0H6C4.896 0 4 0.896 4 2V14C4 15.104 4.896 16 6 16H18C19.104 16 20 15.104 20 14V2C20 0.896 19.104 0 18 0ZM12 2.5C13.381 2.5 14.5 3.619 14.5 5C14.5 6.381 13.381 7.5 12 7.5C10.619 7.5 9.5 6.381 9.5 5C9.5 3.619 10.619 2.5 12 2.5ZM17 13H7V12.75C7 10.901 9.254 9 12 9C14.746 9 17 10.901 17 12.75V13Z" />
                        <path class="primary-fill" d="M2 6H0V18C0 19.103 0.897 20 2 20H14V18H2V6Z" />
                      </svg>
                    </span>
                    <span class="text">Landlords & Properties</span>
                  </router-link>
                </li>

                <li v-if="checkUser.show_partner_button == 'YES' && userTypeSelect === 'partner'">
                  <router-link :to="'/user/partner/assigned-requests/' + user.id" class="nav-item">
                    <span class="icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" class="" fill="none" style="background: #ffffff !important; border-radius: 50px !important;">
                        <path class="" d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z" stroke="#555C74" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path class="" d="M15.7128 15.1798L12.6128 13.3298C12.0728 13.0098 11.6328 12.2398 11.6328 11.6098V7.50977" stroke="#555C74" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    <span class="text">Assigned Requests <span class="requestCount">{{ requestNumber }}</span></span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect != 'partner'">
                  <router-link to="/user/dashboard" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="18" viewBox="0 0 21 18" fill="none">
                        <path class="primary-fill"
                          d="M19.9898 2.78509C19.5476 1.38109 16.2567 0 10.5 0C4.74337 0 1.4521 1.38109 1.01034 2.78509C0.978263 2.8332 0.95459 2.88589 0.95459 2.94545V3.10909V6.87273V7.03636V7.2V10.8V10.9636V11.1273V15.0545C0.95459 15.1076 0.971008 15.1576 0.999263 15.2021C1.45019 16.8041 5.48448 18 10.5 18C15.5042 18 19.532 16.8091 19.9978 15.2129C20.0283 15.1661 20.0455 15.1121 20.0455 15.0545V11.1273V10.9636V10.8V7.2V7.03636V6.87273V3.10909V2.94545C20.0455 2.88589 20.0218 2.8332 19.9898 2.78509ZM19.2517 11.1224C19.241 11.162 19.2261 11.2012 19.2074 11.2412C19.1921 11.2736 19.1734 11.306 19.1528 11.3384C19.1272 11.3786 19.0986 11.4189 19.0646 11.4591C19.0394 11.4896 19.0108 11.5197 18.981 11.5498C18.9386 11.5927 18.8936 11.6355 18.8424 11.6781C18.8115 11.7039 18.7775 11.7295 18.7431 11.7553C18.6805 11.8021 18.6152 11.8486 18.5423 11.8947C18.511 11.9147 18.4774 11.934 18.4442 11.9536C18.3579 12.0047 18.2678 12.0554 18.1689 12.1052C18.1429 12.1186 18.115 12.1313 18.0879 12.1444C17.9741 12.1994 17.8554 12.2541 17.7271 12.3071C17.7107 12.314 17.6935 12.3205 17.6767 12.3271C17.5335 12.385 17.3838 12.4419 17.2239 12.4969C17.2193 12.4985 17.2147 12.4999 17.2101 12.5015C16.343 12.7983 15.2338 13.048 13.9414 13.2117C13.9349 13.2123 13.9284 13.213 13.9219 13.214C13.6707 13.2457 13.4129 13.2739 13.1483 13.2987C13.1052 13.3027 13.0598 13.3053 13.0162 13.3092C12.7852 13.3298 12.5516 13.3488 12.311 13.3639C12.201 13.3707 12.0857 13.374 11.9739 13.3799C11.7929 13.3891 11.6138 13.3992 11.4282 13.4048C11.1251 13.4129 10.8158 13.4182 10.5 13.4182C10.1843 13.4182 9.87501 13.4129 9.57146 13.4038C9.3859 13.3982 9.20683 13.3877 9.02584 13.3789C8.91397 13.3733 8.79866 13.3697 8.6887 13.3629C8.44815 13.3478 8.21448 13.3288 7.98348 13.3082C7.93995 13.3043 7.89452 13.3017 7.85137 13.2977C7.58677 13.2729 7.32904 13.2444 7.07781 13.213C7.07132 13.2123 7.06483 13.2117 7.05834 13.2107C5.76588 13.0471 4.6567 12.7973 3.78959 12.5005C3.78501 12.4992 3.78043 12.4976 3.77584 12.4959C3.61586 12.4409 3.46581 12.384 3.32301 12.3261C3.30659 12.3192 3.28903 12.3127 3.27261 12.3061C3.14432 12.2531 3.02557 12.1988 2.91179 12.1435C2.88506 12.1304 2.85681 12.1176 2.83084 12.1042C2.73195 12.0544 2.64184 12.0037 2.55555 11.9527C2.52272 11.933 2.48874 11.9137 2.45743 11.8937C2.3845 11.8476 2.31921 11.8011 2.25659 11.7543C2.22261 11.7288 2.18824 11.7033 2.15732 11.6771C2.10615 11.6345 2.0611 11.592 2.01872 11.5488C1.98894 11.5187 1.9603 11.4886 1.9351 11.4581C1.9015 11.4179 1.87286 11.3776 1.8469 11.3374C1.82628 11.305 1.80795 11.2726 1.7923 11.2402C1.77359 11.2006 1.7587 11.161 1.74801 11.1214C1.73388 11.0693 1.71823 11.0163 1.71823 10.9636C1.71823 10.9267 1.72319 10.8897 1.73006 10.853C1.73961 10.8036 1.73426 10.7542 1.71823 10.7074V8.27771C1.72892 8.28622 1.74228 8.2944 1.75335 8.30291C1.83659 8.36575 1.92135 8.42825 2.01681 8.48847C3.45512 9.42087 6.33135 10.1455 10.5 10.1455C14.6512 10.1455 17.5202 9.42676 18.9646 8.49993C19.0799 8.42793 19.1837 8.35364 19.2815 8.27804L19.2819 8.27771V10.7074C19.2658 10.7542 19.2605 10.8036 19.27 10.853C19.2773 10.8897 19.2819 10.9267 19.2819 10.9636C19.2819 11.0163 19.2662 11.0693 19.2517 11.1224ZM19.2819 4.35044V6.78011C19.2658 6.82691 19.2605 6.87633 19.27 6.92575C19.2773 6.9624 19.2819 6.99938 19.2819 7.03636C19.2819 7.08905 19.2662 7.14207 19.2517 7.19509C19.241 7.23469 19.2261 7.27396 19.2074 7.31389C19.1921 7.34629 19.1734 7.37869 19.1528 7.41109C19.1272 7.45135 19.0986 7.4916 19.0646 7.53185C19.0394 7.56229 19.0108 7.5924 18.981 7.62251C18.9386 7.66538 18.8936 7.70825 18.8424 7.7508C18.8115 7.77665 18.7775 7.80218 18.7431 7.82804C18.6805 7.87484 18.6152 7.92131 18.5423 7.96745C18.511 7.98742 18.4774 8.00673 18.4442 8.02636C18.3579 8.07742 18.2678 8.12815 18.1689 8.17789C18.1429 8.19131 18.115 8.20407 18.0879 8.21716C17.9741 8.27215 17.8554 8.3268 17.7271 8.37982C17.7107 8.38669 17.6935 8.39324 17.6767 8.39978C17.5335 8.45771 17.3838 8.51465 17.2239 8.56964C17.2193 8.57127 17.2147 8.57258 17.2101 8.57422C16.343 8.87105 15.2338 9.12076 13.9414 9.2844C13.9349 9.28505 13.9284 9.28571 13.9219 9.28669C13.6707 9.31844 13.4129 9.34658 13.1483 9.37145C13.1052 9.37538 13.0598 9.378 13.0162 9.38193C12.7852 9.40254 12.5516 9.42153 12.311 9.43658C12.201 9.44345 12.0857 9.44673 11.9739 9.45262C11.7929 9.46178 11.6138 9.47193 11.4282 9.47749C11.1251 9.48567 10.8158 9.49091 10.5 9.49091C10.1843 9.49091 9.87501 9.48567 9.57146 9.47651C9.3859 9.47094 9.20683 9.46047 9.02584 9.45164C8.91397 9.44607 8.79866 9.44247 8.6887 9.4356C8.44815 9.42054 8.21448 9.40156 7.98348 9.38095C7.93995 9.37702 7.89452 9.3744 7.85137 9.37047C7.58677 9.3456 7.32904 9.31713 7.07781 9.28571C7.07132 9.28505 7.06483 9.2844 7.05834 9.28342C5.76588 9.11978 4.6567 8.87007 3.78959 8.57324C3.78501 8.57193 3.78043 8.57029 3.77584 8.56865C3.61586 8.51367 3.46581 8.45673 3.32301 8.3988C3.30659 8.39193 3.28903 8.38538 3.27261 8.37884C3.14432 8.32582 3.02557 8.27149 2.91179 8.21618C2.88506 8.20309 2.85681 8.19033 2.83084 8.17691C2.73195 8.12716 2.64184 8.07644 2.55555 8.02538C2.52272 8.00574 2.48874 7.98644 2.45743 7.96647C2.3845 7.92033 2.31921 7.87385 2.25659 7.82705C2.22261 7.80153 2.18824 7.776 2.15732 7.74982C2.10615 7.70727 2.0611 7.66473 2.01872 7.62153C1.98894 7.59142 1.9603 7.56131 1.9351 7.53087C1.9015 7.49062 1.87286 7.45036 1.8469 7.41011C1.82628 7.37771 1.80795 7.34531 1.7923 7.31291C1.77359 7.27331 1.7587 7.23371 1.74801 7.19411C1.73388 7.14207 1.71823 7.08905 1.71823 7.03636C1.71823 6.99938 1.72319 6.9624 1.73006 6.92575C1.73961 6.87633 1.73426 6.82691 1.71823 6.78011V4.35044C1.76404 4.38611 1.81635 4.42113 1.86599 4.45647C1.89348 4.47611 1.91906 4.49575 1.94808 4.51538C2.06263 4.59262 2.18634 4.66887 2.32035 4.74316C2.34823 4.75855 2.37954 4.7736 2.40855 4.78898C2.52081 4.84887 2.63955 4.90745 2.76441 4.96505C2.81061 4.98633 2.85681 5.00727 2.90454 5.02822C3.0439 5.08909 3.19014 5.14833 3.34401 5.2056C3.36921 5.21509 3.39212 5.22491 3.4177 5.23407C3.59677 5.2992 3.78692 5.36138 3.9847 5.4216C4.0393 5.43829 4.09657 5.454 4.1527 5.47036C4.31001 5.51585 4.47266 5.55938 4.64104 5.6016C4.70175 5.61665 4.76132 5.63236 4.82355 5.64676C5.04692 5.69978 5.27754 5.75018 5.51961 5.79665C5.55283 5.8032 5.58872 5.80844 5.62232 5.81465C5.83575 5.85458 6.05721 5.89156 6.28477 5.92625C6.3619 5.93804 6.44017 5.94916 6.51883 5.96029C6.73532 5.99073 6.9583 6.01855 7.18701 6.04407C7.24581 6.05062 7.30194 6.05815 7.3615 6.06436C7.64557 6.09382 7.93957 6.11902 8.24159 6.14062C8.31604 6.14585 8.39355 6.14978 8.46915 6.15436C8.71084 6.16942 8.95788 6.18185 9.21064 6.19167C9.30266 6.19527 9.3943 6.19887 9.48823 6.20182C9.81735 6.21131 10.1526 6.21818 10.5 6.21818C10.8475 6.21818 11.1827 6.21131 11.5119 6.20182C11.6054 6.19887 11.697 6.19527 11.7894 6.19167C12.0422 6.18185 12.2892 6.16942 12.5309 6.15436C12.6065 6.14945 12.6837 6.14585 12.7585 6.14062C13.0605 6.11935 13.3545 6.09382 13.6386 6.06436C13.6982 6.05815 13.7543 6.05062 13.8131 6.04407C14.0418 6.01855 14.2644 5.99073 14.4813 5.96029C14.5599 5.94916 14.6382 5.93804 14.7153 5.92625C14.9429 5.89156 15.1643 5.85458 15.3778 5.81465C15.4114 5.80844 15.4473 5.80287 15.4805 5.79665C15.7226 5.75018 15.9532 5.69945 16.1765 5.64676C16.2388 5.63204 16.2983 5.61665 16.359 5.6016C16.5274 5.55938 16.6901 5.51585 16.8474 5.47036C16.9035 5.454 16.9608 5.43829 17.0154 5.4216C17.2132 5.36138 17.4037 5.2992 17.5824 5.23407C17.608 5.22491 17.6309 5.21509 17.6561 5.2056C17.81 5.148 17.9562 5.08909 18.0956 5.02822C18.1433 5.00727 18.1899 4.98633 18.2357 4.96505C18.3605 4.90778 18.4793 4.8492 18.5915 4.78898C18.6206 4.7736 18.6519 4.75855 18.6797 4.74316C18.8138 4.66887 18.9375 4.59295 19.052 4.51538C19.0806 4.49575 19.1062 4.47611 19.1341 4.45647C19.1837 4.42113 19.236 4.38611 19.2819 4.35044ZM10.5 0.654545C15.6756 0.654545 19.2819 1.94793 19.2819 3.10909C19.2819 4.27025 15.6756 5.56364 10.5 5.56364C5.3245 5.56364 1.71823 4.27025 1.71823 3.10909C1.71823 1.94793 5.3245 0.654545 10.5 0.654545ZM19.2819 14.9573C19.2765 14.9717 19.2727 14.9865 19.2696 15.0015C19.0532 16.1336 15.4774 17.3455 10.5 17.3455C5.52266 17.3455 1.94694 16.1336 1.73044 15.0015C1.72739 14.9868 1.72319 14.9724 1.71823 14.9587V12.205C1.72892 12.2135 1.74228 12.2217 1.75335 12.2302C1.83659 12.293 1.92135 12.3555 2.01681 12.4157C3.45512 13.3481 6.33135 14.0727 10.5 14.0727C14.6512 14.0727 17.5202 13.354 18.9646 12.4272C19.0799 12.3552 19.1837 12.2809 19.2815 12.2053L19.2819 12.205V14.9573Z" />
                      </svg>
                    </span>
                    <span class="text">Dashboard</span>
                  </router-link>
                </li>

                
                <!-- <li v-if="checkUser.show_agent_button == 'YES'">
                  <router-link to="/user/partner/dashboard" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="20" viewBox="0 0 17 18" fill="none">
                        <path
                          d="M7.96446 11.4676C8.51071 11.6838 9.00946 11.9711 9.45833 12.3286C9.90721 12.6848 10.2908 13.1004 10.6102 13.5707C11.2617 14.5196 11.6126 15.6426 11.6172 16.7936V17.3125H10.5781V16.7924C10.5804 16.1782 10.4602 15.5698 10.2247 15.0026C9.98925 14.4354 9.64313 13.9207 9.20658 13.4887C8.77808 13.0663 8.27419 12.728 7.72102 12.4912C7.1461 12.2449 6.52723 12.1177 5.90177 12.1172C5.28762 12.115 4.67918 12.2351 4.11196 12.4706C3.54475 12.7061 3.03013 13.0522 2.59814 13.4887C2.17586 13.9174 1.83753 14.4212 1.60064 14.9743C1.35602 15.5372 1.23252 16.144 1.22658 16.7924V17.3125H0.18752V16.7924C0.184482 15.6406 0.536069 14.5157 1.19452 13.5707C1.85037 12.6245 2.77126 11.8932 3.84146 11.4688C3.59833 11.3018 3.37695 11.1051 3.18239 10.8834C2.99015 10.6651 2.82397 10.4252 2.68721 10.1685C2.55098 9.91203 2.44726 9.63957 2.37846 9.35744C2.30829 9.07003 2.27045 8.77568 2.26564 8.47987C2.26564 7.97756 2.36064 7.50612 2.55064 7.06794C2.92216 6.19978 3.61359 5.50793 4.48152 5.13587C4.92929 4.94526 5.41072 4.84632 5.89737 4.84489C6.38401 4.84346 6.86601 4.93958 7.31489 5.12756C8.18327 5.49936 8.87515 6.19125 9.24696 7.05963C9.55444 7.7827 9.61984 8.58583 9.43339 9.34912C9.36214 9.63056 9.25764 9.90131 9.11752 10.1614C8.97829 10.4188 8.81231 10.6608 8.62233 10.8834C8.43233 11.1054 8.21264 11.299 7.96446 11.4676ZM5.90177 11.0781C6.25921 11.0781 6.59527 11.0104 6.90877 10.8763C7.53034 10.6121 8.02507 10.117 8.28864 9.49519C8.42996 9.17575 8.50002 8.83731 8.50002 8.48106C8.50154 8.14102 8.43474 7.80413 8.30357 7.49039C8.17241 7.17665 7.97955 6.89247 7.73646 6.65469C7.49601 6.42022 7.21574 6.23043 6.90877 6.09419C6.59202 5.95271 6.24867 5.88064 5.90177 5.88281C5.54552 5.88281 5.20946 5.9505 4.89596 6.08469C4.27096 6.35126 3.77316 6.84906 3.50658 7.47406C3.37239 7.78756 3.30471 8.12363 3.30471 8.48106C3.30471 8.83731 3.37239 9.17338 3.50658 9.48687C3.64314 9.80037 3.82721 10.0771 4.05996 10.3146C4.30091 10.558 4.58803 10.751 4.90449 10.8821C5.22096 11.0132 5.56041 11.0799 5.90296 11.0781H5.90177ZM16.8125 0.6875V9H14.7344L11.6172 12.1172V9H10.5781V7.96094H12.6563V9.60919L14.3045 7.96094H15.7735V1.72656H5.38283V3.59331C5.20866 3.61532 5.03521 3.64264 4.86271 3.67525C4.68583 3.70883 4.5122 3.7577 4.34377 3.82131V0.6875H16.8125Z"
                          class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text">Agent</span>
                  </router-link>
                </li> -->
                <li v-if="userTypeSelect === 'associate' && configg.show_facility_management_dashboard == 'YES'">
                  <router-link to="/user/facility-manager-dashboard" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="18" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="primary-fill"
                          d="M1.1 9.16615L0.462 8.48782L0 8.73782V9.16615H1.1ZM16.5 0.83282L17.138 0.154486C16.9517 0.0539995 16.7287 0 16.5 0C16.2713 0 16.0483 0.0539995 15.862 0.154486L16.5 0.83282ZM31.9 9.16615H33V8.73782L32.538 8.48782L31.9 9.16615ZM5.5 14.1662V13.3328H4.4V14.1662H5.5ZM14.3 14.1662H15.4V13.3328H14.3V14.1662ZM2.2 24.9995V9.16615H0V24.9995H2.2ZM1.738 9.84449L17.138 1.51115L15.862 0.154486L0.462 8.48782L1.738 9.84449ZM15.862 1.51115L31.262 9.84449L32.538 8.48782L17.138 0.154486L15.862 1.51115ZM30.8 9.16615V24.9995H33V9.16615H30.8ZM6.6 24.9995V14.1662H4.4V24.9995H6.6ZM5.5 14.9995H14.3V13.3328H5.5V14.9995ZM13.2 14.1662V24.9995H15.4V14.1662H13.2ZM11 19.9995H14.3V18.3328H11V19.9995ZM24.2 13.3328V19.9995H26.4V13.3328H24.2ZM28.6 3.33282V7.49949H30.8V3.33282H28.6Z" />
                      </svg>
                    </span>
                    <span class="text">Facility Management</span>
                  </router-link>
                </li>

                <li  v-if="userTypeSelect === 'vendor' && (userPlans == '1' || userPlans == '3' || userPlans == '4' || userPlans == '5')">
                  <router-link to="/user/vendors/profile-setup" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path class="primary-fill"
                          d="M18 0H6C4.896 0 4 0.896 4 2V14C4 15.104 4.896 16 6 16H18C19.104 16 20 15.104 20 14V2C20 0.896 19.104 0 18 0ZM12 2.5C13.381 2.5 14.5 3.619 14.5 5C14.5 6.381 13.381 7.5 12 7.5C10.619 7.5 9.5 6.381 9.5 5C9.5 3.619 10.619 2.5 12 2.5ZM17 13H7V12.75C7 10.901 9.254 9 12 9C14.746 9 17 10.901 17 12.75V13Z" />
                        <path class="primary-fill" d="M2 6H0V18C0 19.103 0.897 20 2 20H14V18H2V6Z" />
                      </svg>
                    </span>
                    <span class="text">Profile Setup</span>
                  </router-link>
                </li>

                <!-- <li  v-if="userTypeSelect === 'vendor' && userPlans == '1'">
                  <router-link to="/user/vendor-profile-overview" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path  class="primary-fill"
                          d="M16.875 3.375C16.875 4.41047 16.0359 5.25 15 5.25C13.9641 5.25 13.125 4.41047 13.125 3.375C13.125 2.33953 13.9641 1.5 15 1.5C16.0359 1.5 16.875 2.33953 16.875 3.375ZM4.875 7.875C4.875 6.83906 5.71406 6 6.75 6C7.78594 6 8.625 6.83906 8.625 7.875C8.625 8.91094 7.78594 9.75 6.75 9.75C5.71406 9.75 4.875 8.91094 4.875 7.875ZM21.375 7.875C21.375 6.83906 22.2141 6 23.25 6C24.2859 6 25.125 6.83906 25.125 7.875C25.125 8.91094 24.2859 9.75 23.25 9.75C22.2141 9.75 21.375 8.91094 21.375 7.875ZM9.375 16.5C9.375 17.3297 8.70469 18 7.875 18H5.625C4.79531 18 4.125 17.3297 4.125 16.5V14.6953L2.86547 17.0344C2.57109 17.5781 1.88859 17.7844 1.34156 17.4891C0.794532 17.1938 0.589688 16.5141 0.884532 15.9656L2.66016 12.6703C3.37922 11.3344 4.77656 10.5 6.29062 10.5H7.20937C7.97344 10.5 8.70469 10.7109 9.3375 11.0906L10.9078 8.17031C11.6297 6.83438 13.0266 6 14.5406 6H15.4594C16.9734 6 18.3703 6.83438 19.0922 8.17031L20.6625 11.0906C21.2953 10.7109 22.0266 10.5 22.7906 10.5H23.7094C25.2234 10.5 26.6203 11.3344 27.3422 12.6703L29.1141 15.9656C29.4094 16.5141 29.2031 17.1938 28.6594 17.4891C28.1109 17.7844 27.4312 17.5781 27.1359 17.0344L25.875 14.6953V16.5C25.875 17.3297 25.2047 18 24.375 18H22.125C21.2953 18 20.625 17.3297 20.625 16.5V14.6953L19.3641 17.0344C19.0687 17.5781 18.3891 17.7844 17.8406 17.4891C17.2547 17.1938 17.0906 16.5141 17.3859 15.9656L19.0875 12.8016C19.0078 12.7266 18.9375 12.6375 18.8859 12.5344L17.625 10.1953V12.75C17.625 13.5797 16.9547 14.25 16.125 14.25H13.8328C13.0453 14.25 12.3328 13.5797 12.3328 12.75V10.1953L11.1141 12.5344C11.0203 12.6375 10.9922 12.7266 10.9125 12.8016L12.6141 15.9656C12.9094 16.5141 12.7031 17.1938 12.1594 17.4891C11.6109 17.7844 10.9312 17.5781 10.6359 17.0344L9.33281 14.6953L9.375 16.5Z"
                          fill="" />
                      </svg>
                    </span>
                    <span class="text">Profile Overview</span>
                  </router-link>
                </li> -->

                <li  v-if="userTypeSelect === 'vendor' && (userPlans == '1' || userPlans == '3' || userPlans == '4' || userPlans == '5')">
                  <!-- <router-link to="/user/vendor/profile-overview" class="nav-item"> -->
                  <router-link to="/user/vendor-profile-overview" class="nav-item">
                    <span class="icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="primary-fill" d="M12.1625 10.87C12.0625 10.86 11.9425 10.86 11.8325 10.87C9.4525 10.79 7.5625 8.84 7.5625 6.44C7.5625 3.99 9.5425 2 12.0025 2C14.4525 2 16.4425 3.99 16.4425 6.44C16.4325 8.84 14.5425 10.79 12.1625 10.87Z" stroke="#555C74" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.15875 14.56C4.73875 16.18 4.73875 18.82 7.15875 20.43C9.90875 22.27 14.4188 22.27 17.1688 20.43C19.5888 18.81 19.5888 16.17 17.1688 14.56C14.4288 12.73 9.91875 12.73 7.15875 14.56Z" stroke="#555C74" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    <span class="text">Vendor Overview</span>
                  </router-link>
                </li>

                <li  v-if="userTypeSelect === 'agent' && (userPlans == '2' && userPlans == '3' || userPlans == '4' || userPlans == '5')">
                  <router-link to="/user/agent-profile-overview" class="nav-item">
                    <span class="icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="primary-fill" d="M12.1625 10.87C12.0625 10.86 11.9425 10.86 11.8325 10.87C9.4525 10.79 7.5625 8.84 7.5625 6.44C7.5625 3.99 9.5425 2 12.0025 2C14.4525 2 16.4425 3.99 16.4425 6.44C16.4325 8.84 14.5425 10.79 12.1625 10.87Z" stroke="#555C74" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.15875 14.56C4.73875 16.18 4.73875 18.82 7.15875 20.43C9.90875 22.27 14.4188 22.27 17.1688 20.43C19.5888 18.81 19.5888 16.17 17.1688 14.56C14.4288 12.73 9.91875 12.73 7.15875 14.56Z" stroke="#555C74" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    <span class="text">Agent Overview</span>
                  </router-link>
                </li>

                <li  v-if="userTypeSelect === 'agent' && (userPlans == '2' && userPlans == '3' || userPlans == '4' || userPlans == '5')">
                  <router-link to="/user/smart-agent" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="18" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="primary-fill"
                          d="M1.1 9.16615L0.462 8.48782L0 8.73782V9.16615H1.1ZM16.5 0.83282L17.138 0.154486C16.9517 0.0539995 16.7287 0 16.5 0C16.2713 0 16.0483 0.0539995 15.862 0.154486L16.5 0.83282ZM31.9 9.16615H33V8.73782L32.538 8.48782L31.9 9.16615ZM5.5 14.1662V13.3328H4.4V14.1662H5.5ZM14.3 14.1662H15.4V13.3328H14.3V14.1662ZM2.2 24.9995V9.16615H0V24.9995H2.2ZM1.738 9.84449L17.138 1.51115L15.862 0.154486L0.462 8.48782L1.738 9.84449ZM15.862 1.51115L31.262 9.84449L32.538 8.48782L17.138 0.154486L15.862 1.51115ZM30.8 9.16615V24.9995H33V9.16615H30.8ZM6.6 24.9995V14.1662H4.4V24.9995H6.6ZM5.5 14.9995H14.3V13.3328H5.5V14.9995ZM13.2 14.1662V24.9995H15.4V14.1662H13.2ZM11 19.9995H14.3V18.3328H11V19.9995ZM24.2 13.3328V19.9995H26.4V13.3328H24.2ZM28.6 3.33282V7.49949H30.8V3.33282H28.6Z" />
                      </svg>
                    </span>
                    <span class="text">Property List</span>
                  </router-link>
                </li>
                
                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/landlords" id="properties-landlord" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="primary-fill"
                          d="M16.875 3.375C16.875 4.41047 16.0359 5.25 15 5.25C13.9641 5.25 13.125 4.41047 13.125 3.375C13.125 2.33953 13.9641 1.5 15 1.5C16.0359 1.5 16.875 2.33953 16.875 3.375ZM4.875 7.875C4.875 6.83906 5.71406 6 6.75 6C7.78594 6 8.625 6.83906 8.625 7.875C8.625 8.91094 7.78594 9.75 6.75 9.75C5.71406 9.75 4.875 8.91094 4.875 7.875ZM21.375 7.875C21.375 6.83906 22.2141 6 23.25 6C24.2859 6 25.125 6.83906 25.125 7.875C25.125 8.91094 24.2859 9.75 23.25 9.75C22.2141 9.75 21.375 8.91094 21.375 7.875ZM9.375 16.5C9.375 17.3297 8.70469 18 7.875 18H5.625C4.79531 18 4.125 17.3297 4.125 16.5V14.6953L2.86547 17.0344C2.57109 17.5781 1.88859 17.7844 1.34156 17.4891C0.794532 17.1938 0.589688 16.5141 0.884532 15.9656L2.66016 12.6703C3.37922 11.3344 4.77656 10.5 6.29062 10.5H7.20937C7.97344 10.5 8.70469 10.7109 9.3375 11.0906L10.9078 8.17031C11.6297 6.83438 13.0266 6 14.5406 6H15.4594C16.9734 6 18.3703 6.83438 19.0922 8.17031L20.6625 11.0906C21.2953 10.7109 22.0266 10.5 22.7906 10.5H23.7094C25.2234 10.5 26.6203 11.3344 27.3422 12.6703L29.1141 15.9656C29.4094 16.5141 29.2031 17.1938 28.6594 17.4891C28.1109 17.7844 27.4312 17.5781 27.1359 17.0344L25.875 14.6953V16.5C25.875 17.3297 25.2047 18 24.375 18H22.125C21.2953 18 20.625 17.3297 20.625 16.5V14.6953L19.3641 17.0344C19.0687 17.5781 18.3891 17.7844 17.8406 17.4891C17.2547 17.1938 17.0906 16.5141 17.3859 15.9656L19.0875 12.8016C19.0078 12.7266 18.9375 12.6375 18.8859 12.5344L17.625 10.1953V12.75C17.625 13.5797 16.9547 14.25 16.125 14.25H13.8328C13.0453 14.25 12.3328 13.5797 12.3328 12.75V10.1953L11.1141 12.5344C11.0203 12.6375 10.9922 12.7266 10.9125 12.8016L12.6141 15.9656C12.9094 16.5141 12.7031 17.1938 12.1594 17.4891C11.6109 17.7844 10.9312 17.5781 10.6359 17.0344L9.33281 14.6953L9.375 16.5Z"
                          />
                      </svg>
                    </span>
                    <span class="text">Landlords</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/register-tenant" id="properties-landlord" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="primary-fill"
                          d="M16.875 3.375C16.875 4.41047 16.0359 5.25 15 5.25C13.9641 5.25 13.125 4.41047 13.125 3.375C13.125 2.33953 13.9641 1.5 15 1.5C16.0359 1.5 16.875 2.33953 16.875 3.375ZM4.875 7.875C4.875 6.83906 5.71406 6 6.75 6C7.78594 6 8.625 6.83906 8.625 7.875C8.625 8.91094 7.78594 9.75 6.75 9.75C5.71406 9.75 4.875 8.91094 4.875 7.875ZM21.375 7.875C21.375 6.83906 22.2141 6 23.25 6C24.2859 6 25.125 6.83906 25.125 7.875C25.125 8.91094 24.2859 9.75 23.25 9.75C22.2141 9.75 21.375 8.91094 21.375 7.875ZM9.375 16.5C9.375 17.3297 8.70469 18 7.875 18H5.625C4.79531 18 4.125 17.3297 4.125 16.5V14.6953L2.86547 17.0344C2.57109 17.5781 1.88859 17.7844 1.34156 17.4891C0.794532 17.1938 0.589688 16.5141 0.884532 15.9656L2.66016 12.6703C3.37922 11.3344 4.77656 10.5 6.29062 10.5H7.20937C7.97344 10.5 8.70469 10.7109 9.3375 11.0906L10.9078 8.17031C11.6297 6.83438 13.0266 6 14.5406 6H15.4594C16.9734 6 18.3703 6.83438 19.0922 8.17031L20.6625 11.0906C21.2953 10.7109 22.0266 10.5 22.7906 10.5H23.7094C25.2234 10.5 26.6203 11.3344 27.3422 12.6703L29.1141 15.9656C29.4094 16.5141 29.2031 17.1938 28.6594 17.4891C28.1109 17.7844 27.4312 17.5781 27.1359 17.0344L25.875 14.6953V16.5C25.875 17.3297 25.2047 18 24.375 18H22.125C21.2953 18 20.625 17.3297 20.625 16.5V14.6953L19.3641 17.0344C19.0687 17.5781 18.3891 17.7844 17.8406 17.4891C17.2547 17.1938 17.0906 16.5141 17.3859 15.9656L19.0875 12.8016C19.0078 12.7266 18.9375 12.6375 18.8859 12.5344L17.625 10.1953V12.75C17.625 13.5797 16.9547 14.25 16.125 14.25H13.8328C13.0453 14.25 12.3328 13.5797 12.3328 12.75V10.1953L11.1141 12.5344C11.0203 12.6375 10.9922 12.7266 10.9125 12.8016L12.6141 15.9656C12.9094 16.5141 12.7031 17.1938 12.1594 17.4891C11.6109 17.7844 10.9312 17.5781 10.6359 17.0344L9.33281 14.6953L9.375 16.5Z"
                         />
                      </svg>
                    </span>
                    <span class="text">Register Tenant</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/properties" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="18" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="primary-fill"
                          d="M1.1 9.16615L0.462 8.48782L0 8.73782V9.16615H1.1ZM16.5 0.83282L17.138 0.154486C16.9517 0.0539995 16.7287 0 16.5 0C16.2713 0 16.0483 0.0539995 15.862 0.154486L16.5 0.83282ZM31.9 9.16615H33V8.73782L32.538 8.48782L31.9 9.16615ZM5.5 14.1662V13.3328H4.4V14.1662H5.5ZM14.3 14.1662H15.4V13.3328H14.3V14.1662ZM2.2 24.9995V9.16615H0V24.9995H2.2ZM1.738 9.84449L17.138 1.51115L15.862 0.154486L0.462 8.48782L1.738 9.84449ZM15.862 1.51115L31.262 9.84449L32.538 8.48782L17.138 0.154486L15.862 1.51115ZM30.8 9.16615V24.9995H33V9.16615H30.8ZM6.6 24.9995V14.1662H4.4V24.9995H6.6ZM5.5 14.9995H14.3V13.3328H5.5V14.9995ZM13.2 14.1662V24.9995H15.4V14.1662H13.2ZM11 19.9995H14.3V18.3328H11V19.9995ZM24.2 13.3328V19.9995H26.4V13.3328H24.2ZM28.6 3.33282V7.49949H30.8V3.33282H28.6Z" />
                      </svg>
                    </span>
                    <span class="text">Properties</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/recruit-realtor" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path  class="primary-fill"
                          d="M16.875 3.375C16.875 4.41047 16.0359 5.25 15 5.25C13.9641 5.25 13.125 4.41047 13.125 3.375C13.125 2.33953 13.9641 1.5 15 1.5C16.0359 1.5 16.875 2.33953 16.875 3.375ZM4.875 7.875C4.875 6.83906 5.71406 6 6.75 6C7.78594 6 8.625 6.83906 8.625 7.875C8.625 8.91094 7.78594 9.75 6.75 9.75C5.71406 9.75 4.875 8.91094 4.875 7.875ZM21.375 7.875C21.375 6.83906 22.2141 6 23.25 6C24.2859 6 25.125 6.83906 25.125 7.875C25.125 8.91094 24.2859 9.75 23.25 9.75C22.2141 9.75 21.375 8.91094 21.375 7.875ZM9.375 16.5C9.375 17.3297 8.70469 18 7.875 18H5.625C4.79531 18 4.125 17.3297 4.125 16.5V14.6953L2.86547 17.0344C2.57109 17.5781 1.88859 17.7844 1.34156 17.4891C0.794532 17.1938 0.589688 16.5141 0.884532 15.9656L2.66016 12.6703C3.37922 11.3344 4.77656 10.5 6.29062 10.5H7.20937C7.97344 10.5 8.70469 10.7109 9.3375 11.0906L10.9078 8.17031C11.6297 6.83438 13.0266 6 14.5406 6H15.4594C16.9734 6 18.3703 6.83438 19.0922 8.17031L20.6625 11.0906C21.2953 10.7109 22.0266 10.5 22.7906 10.5H23.7094C25.2234 10.5 26.6203 11.3344 27.3422 12.6703L29.1141 15.9656C29.4094 16.5141 29.2031 17.1938 28.6594 17.4891C28.1109 17.7844 27.4312 17.5781 27.1359 17.0344L25.875 14.6953V16.5C25.875 17.3297 25.2047 18 24.375 18H22.125C21.2953 18 20.625 17.3297 20.625 16.5V14.6953L19.3641 17.0344C19.0687 17.5781 18.3891 17.7844 17.8406 17.4891C17.2547 17.1938 17.0906 16.5141 17.3859 15.9656L19.0875 12.8016C19.0078 12.7266 18.9375 12.6375 18.8859 12.5344L17.625 10.1953V12.75C17.625 13.5797 16.9547 14.25 16.125 14.25H13.8328C13.0453 14.25 12.3328 13.5797 12.3328 12.75V10.1953L11.1141 12.5344C11.0203 12.6375 10.9922 12.7266 10.9125 12.8016L12.6141 15.9656C12.9094 16.5141 12.7031 17.1938 12.1594 17.4891C11.6109 17.7844 10.9312 17.5781 10.6359 17.0344L9.33281 14.6953L9.375 16.5Z"
                          fill="" />
                      </svg>
                    </span>
                    <span class="text">Recruit SMARTA</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/feedback" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="20" viewBox="0 0 17 18" fill="none">
                        <path
                          d="M7.96446 11.4676C8.51071 11.6838 9.00946 11.9711 9.45833 12.3286C9.90721 12.6848 10.2908 13.1004 10.6102 13.5707C11.2617 14.5196 11.6126 15.6426 11.6172 16.7936V17.3125H10.5781V16.7924C10.5804 16.1782 10.4602 15.5698 10.2247 15.0026C9.98925 14.4354 9.64313 13.9207 9.20658 13.4887C8.77808 13.0663 8.27419 12.728 7.72102 12.4912C7.1461 12.2449 6.52723 12.1177 5.90177 12.1172C5.28762 12.115 4.67918 12.2351 4.11196 12.4706C3.54475 12.7061 3.03013 13.0522 2.59814 13.4887C2.17586 13.9174 1.83753 14.4212 1.60064 14.9743C1.35602 15.5372 1.23252 16.144 1.22658 16.7924V17.3125H0.18752V16.7924C0.184482 15.6406 0.536069 14.5157 1.19452 13.5707C1.85037 12.6245 2.77126 11.8932 3.84146 11.4688C3.59833 11.3018 3.37695 11.1051 3.18239 10.8834C2.99015 10.6651 2.82397 10.4252 2.68721 10.1685C2.55098 9.91203 2.44726 9.63957 2.37846 9.35744C2.30829 9.07003 2.27045 8.77568 2.26564 8.47987C2.26564 7.97756 2.36064 7.50612 2.55064 7.06794C2.92216 6.19978 3.61359 5.50793 4.48152 5.13587C4.92929 4.94526 5.41072 4.84632 5.89737 4.84489C6.38401 4.84346 6.86601 4.93958 7.31489 5.12756C8.18327 5.49936 8.87515 6.19125 9.24696 7.05963C9.55444 7.7827 9.61984 8.58583 9.43339 9.34912C9.36214 9.63056 9.25764 9.90131 9.11752 10.1614C8.97829 10.4188 8.81231 10.6608 8.62233 10.8834C8.43233 11.1054 8.21264 11.299 7.96446 11.4676ZM5.90177 11.0781C6.25921 11.0781 6.59527 11.0104 6.90877 10.8763C7.53034 10.6121 8.02507 10.117 8.28864 9.49519C8.42996 9.17575 8.50002 8.83731 8.50002 8.48106C8.50154 8.14102 8.43474 7.80413 8.30357 7.49039C8.17241 7.17665 7.97955 6.89247 7.73646 6.65469C7.49601 6.42022 7.21574 6.23043 6.90877 6.09419C6.59202 5.95271 6.24867 5.88064 5.90177 5.88281C5.54552 5.88281 5.20946 5.9505 4.89596 6.08469C4.27096 6.35126 3.77316 6.84906 3.50658 7.47406C3.37239 7.78756 3.30471 8.12363 3.30471 8.48106C3.30471 8.83731 3.37239 9.17338 3.50658 9.48687C3.64314 9.80037 3.82721 10.0771 4.05996 10.3146C4.30091 10.558 4.58803 10.751 4.90449 10.8821C5.22096 11.0132 5.56041 11.0799 5.90296 11.0781H5.90177ZM16.8125 0.6875V9H14.7344L11.6172 12.1172V9H10.5781V7.96094H12.6563V9.60919L14.3045 7.96094H15.7735V1.72656H5.38283V3.59331C5.20866 3.61532 5.03521 3.64264 4.86271 3.67525C4.68583 3.70883 4.5122 3.7577 4.34377 3.82131V0.6875H16.8125Z"
                          class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text">Feedback</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/lead-directory" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="15" viewBox="0 0 17 13" fill="none">
                        <path
                          d="M15.7857 2H7.54071L6.13821 0.410003C6.02517 0.282606 5.87713 0.179045 5.70618 0.107787C5.53524 0.0365281 5.34624 -0.000405979 5.15464 3.36581e-06H1.21429C0.892237 3.36581e-06 0.583379 0.10536 0.355656 0.292896C0.127933 0.480433 0 0.734787 0 1V12C0 12.2652 0.127933 12.5196 0.355656 12.7071C0.583379 12.8946 0.892237 13 1.21429 13H15.7857C16.1078 13 16.4166 12.8946 16.6443 12.7071C16.8721 12.5196 17 12.2652 17 12V3C17 2.73479 16.8721 2.48043 16.6443 2.2929C16.4166 2.10536 16.1078 2 15.7857 2ZM15.7857 12H1.21429V4H5.6525C5.97455 4 6.28341 3.89465 6.51113 3.70711C6.73885 3.51957 6.86679 3.26522 6.86679 3H1.21429V1H5.15464L6.73929 2.795C6.79581 2.8587 6.86983 2.91048 6.9553 2.94611C7.04078 2.98174 7.13527 3.00021 7.23107 3H15.7857V12Z"
                          class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text">Lead Directory</span>
                  </router-link>
                </li>

                <li v-if="checkUser.show_partner_button == 'YES' && userTypeSelect === 'partner' || userTypeSelect == 'associate'">
                  <router-link to="/user/my-vouchers" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="15" viewBox="0 0 17 13" fill="none">
                        <path
                          d="M15.7857 2H7.54071L6.13821 0.410003C6.02517 0.282606 5.87713 0.179045 5.70618 0.107787C5.53524 0.0365281 5.34624 -0.000405979 5.15464 3.36581e-06H1.21429C0.892237 3.36581e-06 0.583379 0.10536 0.355656 0.292896C0.127933 0.480433 0 0.734787 0 1V12C0 12.2652 0.127933 12.5196 0.355656 12.7071C0.583379 12.8946 0.892237 13 1.21429 13H15.7857C16.1078 13 16.4166 12.8946 16.6443 12.7071C16.8721 12.5196 17 12.2652 17 12V3C17 2.73479 16.8721 2.48043 16.6443 2.2929C16.4166 2.10536 16.1078 2 15.7857 2ZM15.7857 12H1.21429V4H5.6525C5.97455 4 6.28341 3.89465 6.51113 3.70711C6.73885 3.51957 6.86679 3.26522 6.86679 3H1.21429V1H5.15464L6.73929 2.795C6.79581 2.8587 6.86983 2.91048 6.9553 2.94611C7.04078 2.98174 7.13527 3.00021 7.23107 3H15.7857V12Z"
                          class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text">My Vouchers</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/identifier" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.1875 15.6H11.8125V11.7H15.75V9.1H11.8125V5.2H9.1875V9.1H5.25V11.7H9.1875V15.6ZM10.5 26C6.97813 23.0317 4.34787 20.2744 2.60925 17.7281C0.86975 15.1827 0 12.8267 0 10.66C0 7.41 1.05569 4.82083 3.16706 2.8925C5.27756 0.964166 7.72188 0 10.5 0C13.2781 0 15.7224 0.964166 17.8329 2.8925C19.9443 4.82083 21 7.41 21 10.66C21 12.8267 20.1307 15.1827 18.3921 17.7281C16.6526 20.2744 14.0219 23.0317 10.5 26Z"
                          fill="red" class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text"> Property Identifier</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/smart-guarantor" class="nav-item">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.0025 11.4472L11.981 8.83733C11.8254 8.42591 11.6545 8.33096 11.9635 7.79506C12.2243 7.34356 12.2637 6.70638 11.5361 6.65364C10.8765 6.60511 10.6683 7.20431 10.9641 7.74021C11.3433 8.43013 11.1526 8.35839 10.986 8.84788C9.81576 9.55045 7.24946 11.2383 6.96237 11.5042C6.89662 12.8439 6.94046 14.3293 7.53217 15.4707C7.77105 15.9306 8.1721 16.5193 8.41755 16.802C8.7945 17.2345 9.29198 17.3864 9.7281 17.8168C8.68492 18.378 5.33406 19.7009 4.4684 18.7072C3.90736 18.0637 4.09145 12.9241 4.08926 11.732C4.08488 10.1264 4.0279 9.98508 5.12367 9.23398L9.25691 6.3245C9.81576 5.94051 10.7428 5.07336 11.5252 5.09446C12.1234 5.11134 13.3573 6.07132 13.7605 6.37303L17.8784 9.29516C18.972 10.0505 18.8449 10.2784 18.8427 11.8439C18.8339 18.0721 19.6054 19.5954 15.8688 18.5743C15.1543 18.378 14.3172 17.8843 13.3419 18.9604C13.7781 19.1524 16.6687 19.9457 17.1508 19.9879C18.6586 20.1229 19.7675 19.1144 19.9253 17.8168C20.0809 16.534 19.9451 14.3672 19.9451 12.9895C19.9451 8.92594 20.1138 9.49349 16.3334 6.87728C10.3417 2.73143 12.5004 2.85803 4.13748 8.62001C2.82474 9.52303 3.00883 10.3902 3.00883 12.2996C3.00883 13.9073 3.01102 15.5171 3.00664 17.1248C3.00445 18.6354 3.62027 19.6862 5.0119 19.9499C6.06822 20.1503 11.9109 18.454 12.8861 17.9624C15.1302 16.8315 16.386 14.7554 16.0047 11.4409L16.0025 11.4472ZM8.08225 11.9072L8.08444 12.903L12.1015 15.131C11.7224 16.1585 10.7954 15.3124 10.2212 15.0044C9.60537 14.6753 8.75286 14.1626 8.18087 13.8799C8.29483 15.3863 9.89465 16.6627 11.1373 17.378C11.9131 17.8253 14.4026 15.3631 14.4509 14.5023C14.1923 14.3335 12.8488 13.6098 12.5267 13.4305L10.5938 12.3355C12.0051 11.6603 12.0774 12.2553 13.64 13.1245C13.7956 13.2089 14.5714 13.6647 14.6678 13.6815C14.7533 13.4094 14.7336 12.2384 14.7314 11.8206C14.613 11.7384 11.512 9.58843 11.4287 9.60742L8.24223 11.7278C8.13265 11.7911 8.08225 11.77 8.08225 11.9093V11.9072Z"
                          fill="#555C74" class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text">Guarantor's Requests</span>
                  </router-link>
                </li>

                <li v-if="checkUser.show_state_button == 'YES' && (userPlans == '4' || userPlans == '5') && userTypeSelect == 'partner'">
                  <router-link to="/user/vendors/state-bonus" class="nav-item">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.0025 11.4472L11.981 8.83733C11.8254 8.42591 11.6545 8.33096 11.9635 7.79506C12.2243 7.34356 12.2637 6.70638 11.5361 6.65364C10.8765 6.60511 10.6683 7.20431 10.9641 7.74021C11.3433 8.43013 11.1526 8.35839 10.986 8.84788C9.81576 9.55045 7.24946 11.2383 6.96237 11.5042C6.89662 12.8439 6.94046 14.3293 7.53217 15.4707C7.77105 15.9306 8.1721 16.5193 8.41755 16.802C8.7945 17.2345 9.29198 17.3864 9.7281 17.8168C8.68492 18.378 5.33406 19.7009 4.4684 18.7072C3.90736 18.0637 4.09145 12.9241 4.08926 11.732C4.08488 10.1264 4.0279 9.98508 5.12367 9.23398L9.25691 6.3245C9.81576 5.94051 10.7428 5.07336 11.5252 5.09446C12.1234 5.11134 13.3573 6.07132 13.7605 6.37303L17.8784 9.29516C18.972 10.0505 18.8449 10.2784 18.8427 11.8439C18.8339 18.0721 19.6054 19.5954 15.8688 18.5743C15.1543 18.378 14.3172 17.8843 13.3419 18.9604C13.7781 19.1524 16.6687 19.9457 17.1508 19.9879C18.6586 20.1229 19.7675 19.1144 19.9253 17.8168C20.0809 16.534 19.9451 14.3672 19.9451 12.9895C19.9451 8.92594 20.1138 9.49349 16.3334 6.87728C10.3417 2.73143 12.5004 2.85803 4.13748 8.62001C2.82474 9.52303 3.00883 10.3902 3.00883 12.2996C3.00883 13.9073 3.01102 15.5171 3.00664 17.1248C3.00445 18.6354 3.62027 19.6862 5.0119 19.9499C6.06822 20.1503 11.9109 18.454 12.8861 17.9624C15.1302 16.8315 16.386 14.7554 16.0047 11.4409L16.0025 11.4472ZM8.08225 11.9072L8.08444 12.903L12.1015 15.131C11.7224 16.1585 10.7954 15.3124 10.2212 15.0044C9.60537 14.6753 8.75286 14.1626 8.18087 13.8799C8.29483 15.3863 9.89465 16.6627 11.1373 17.378C11.9131 17.8253 14.4026 15.3631 14.4509 14.5023C14.1923 14.3335 12.8488 13.6098 12.5267 13.4305L10.5938 12.3355C12.0051 11.6603 12.0774 12.2553 13.64 13.1245C13.7956 13.2089 14.5714 13.6647 14.6678 13.6815C14.7533 13.4094 14.7336 12.2384 14.7314 11.8206C14.613 11.7384 11.512 9.58843 11.4287 9.60742L8.24223 11.7278C8.13265 11.7911 8.08225 11.77 8.08225 11.9093V11.9072Z"
                          fill="white" class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text">{{ userPlans == 4 ? 'State Bonus' : userPlans == 5 ? 'National Bonus' : ''}}</span>
                  </router-link>
                </li>


                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/account" @click="this.mobileShow = false" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path class="primary-fill"
                          d="M18 0H6C4.896 0 4 0.896 4 2V14C4 15.104 4.896 16 6 16H18C19.104 16 20 15.104 20 14V2C20 0.896 19.104 0 18 0ZM12 2.5C13.381 2.5 14.5 3.619 14.5 5C14.5 6.381 13.381 7.5 12 7.5C10.619 7.5 9.5 6.381 9.5 5C9.5 3.619 10.619 2.5 12 2.5ZM17 13H7V12.75C7 10.901 9.254 9 12 9C14.746 9 17 10.901 17 12.75V13Z" />
                        <path class="primary-fill" d="M2 6H0V18C0 19.103 0.897 20 2 20H14V18H2V6Z" />
                      </svg>
                    </span>
                    <span class="text">Account</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/help-center" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="21" viewBox="0 0 21 21" fill="none">
                        <path
                          d="M10.5 0C4.7103 0 0 4.7103 0 10.5V14.8501C0 15.9253 0.94185 16.8 2.1 16.8H3.15C3.42848 16.8 3.69555 16.6894 3.89246 16.4925C4.08938 16.2955 4.2 16.0285 4.2 15.75V10.3498C4.2 10.0714 4.08938 9.8043 3.89246 9.60739C3.69555 9.41047 3.42848 9.29985 3.15 9.29985H2.1966C2.7804 5.23635 6.2769 2.1 10.5 2.1C14.7231 2.1 18.2196 5.23635 18.8034 9.29985H17.85C17.5715 9.29985 17.3044 9.41047 17.1075 9.60739C16.9106 9.8043 16.8 10.0714 16.8 10.3498V16.8C16.8 17.9581 15.8581 18.9 14.7 18.9H12.6V17.85H8.4V21H14.7C17.0163 21 18.9 19.1163 18.9 16.8C20.0581 16.8 21 15.9253 21 14.8501V10.5C21 4.7103 16.2897 0 10.5 0Z"
                          class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text">Help Center</span>
                  </router-link>
                </li>

                <li v-if="userTypeSelect == 'associate'">
                  <router-link to="/user/plans-billings" class="nav-item">
                    <span class="icon">
                      <svg width="20" height="15" viewBox="0 0 17 13" fill="none">
                        <path
                          d="M15.7857 2H7.54071L6.13821 0.410003C6.02517 0.282606 5.87713 0.179045 5.70618 0.107787C5.53524 0.0365281 5.34624 -0.000405979 5.15464 3.36581e-06H1.21429C0.892237 3.36581e-06 0.583379 0.10536 0.355656 0.292896C0.127933 0.480433 0 0.734787 0 1V12C0 12.2652 0.127933 12.5196 0.355656 12.7071C0.583379 12.8946 0.892237 13 1.21429 13H15.7857C16.1078 13 16.4166 12.8946 16.6443 12.7071C16.8721 12.5196 17 12.2652 17 12V3C17 2.73479 16.8721 2.48043 16.6443 2.2929C16.4166 2.10536 16.1078 2 15.7857 2ZM15.7857 12H1.21429V4H5.6525C5.97455 4 6.28341 3.89465 6.51113 3.70711C6.73885 3.51957 6.86679 3.26522 6.86679 3H1.21429V1H5.15464L6.73929 2.795C6.79581 2.8587 6.86983 2.91048 6.9553 2.94611C7.04078 2.98174 7.13527 3.00021 7.23107 3H15.7857V12Z"
                          class="primary-fill" />
                      </svg>
                    </span>
                    <span class="text">Plans & Billing</span>
                  </router-link>
                </li>

                <li>
                  <div class="nav-item logout-sidebar" style="">
                      <span class="icon">
                        <!-- <span> -->
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="">
                              <path d="M10.09 15.59L12.67 18.17L18.5 12.34L12.67 6.51L10.09 9.09L12.67 11.67H3V13.67H12.67L10.09 15.59Z" class="primary-fill"/>
                              <path d="M19,3H5C3.9,3,3,3.9,3,5V11H5V5H19V19H5V13H3V19C3,20.1,3.9,21,5,21H19C20.1,21,21,20.1,21,19V5C21,3.9,20.1,3,19,3Z" class="primary-fill"/>
                          </svg>

                          <!-- <img src="@/assets/images/power.svg" alt="" /> -->
                        <!-- </span> -->
                      </span>
                      <span class="text" @click="logout()">Logout</span>
                  </div>
                </li>

                
              </ul>
              <!-- <hr> -->
              <div class="profile-bottom" v-if="user">
                <hr>
                <div class="profile-container">
                  <img :src="profileImageSrc" alt="Profile Picture" class="profile-pic">
                  <div class="profile-info">
                      <h3>{{user.firstname}} {{user.lastname}}</h3>
                      <p>{{user.email}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-page">
        <div class="header-navbar">
          <div class="flex align-items-center">
            <button class="toggle-sidebar" @click="mobileShow = true">
              <img src="@/assets/images/bars.svg" class="menu" alt="" />
            </button>
            <div class="logo-blue">
              <router-link to="/">
                <img src="@/assets/images/smart_logo_blue.png" alt="smart realtor logo" />
              </router-link>
            </div>
          </div>
        



          <div class="user-nav-links">
          

            <div class="notification-border">
              <button class="nav-link">
                <img src="@/assets/images/notification.svg" alt="" />
                <span class="notification-counter">0</span>
              </button>
            </div>

          <button class="nav-link"  @click="showDropDown = !showDropDown" v-if="subscription == 'YES'">
            
            <div class="flex">
              
              <img class="profile-image" width="40" :src="profileImageSrc" alt="" />
              <img class="dropdown-icon" width="10" src="@/assets/images/dropdown.svg" alt="" />
            </div>
            
          
          </button>

            <div class="dropdown" v-if="showDropDown">
              <span class="arrow"></span>
              <div class="dropdown-links">
                <button class="dropdown-link" @click="editProfile()">
                  <img src="@/assets/images/user.svg" alt="" /> Account
                </button>

                <button class="dropdown-link" @click="settingsProfile()">
                  <img src="@/assets/images/user.svg" alt="" /> Settings
                </button>
                <button class="dropdown-link" @click="logout()">
                  <img src="@/assets/images/power.svg" alt="" /> Logout
                </button>
              </div>
            </div>

          </div>
        </div>
        <div @click="mobileShow = false" class="page-content">
          <slot></slot>
        </div>
        <SubscriptionBtn></SubscriptionBtn>
      </div>
      </div>
  </div>
</template>

<script>
import SubscriptionBtn from "./SubscriptionBtn";
// import AssociateSidebar from "./AssociateSidebar.vue";
// import AssociateSidebarLinks from "./AssociateSidebarLinks.vue";
// import UserStatusSwitch from '../UserStatusSwitch.vue';
import { mapGetters } from "vuex";
import partners from "../../services/partners";
export default {
  components: { 
    SubscriptionBtn,
    // AssociateSidebar,
    // AssociateSidebarLinks
  },
  name: "SidebarLayout",
  data() {
    return {
      mobileShow: false,
      showDropDown: false,
      firstName: "",
      lastName: "",
      userCode: "",
      subscription: "",
      accountType: "",
      user: "",
      userTypeSelect: "associate",
      checkUser: "",
      userPlans: null,
      getCookies: "",
      configg: "",
      requestNumber: "",
    };
  },
  mounted() {
    if (localStorage.getItem("smartUser")) {
      this.subscription;
      this.user = JSON.parse(localStorage.getItem("smartUser")).user;
    }
    this.fetchUserOptions();
    this.smartConfigur();
    this.requestCountNumber();

    // this.getCookies = this.$cookies.get('shelta-c');
    // if (this.getCookies) {
    //   this.$store.dispatch('updateUserToken', this.getCookies);
    // }
    // console.log("Cooked", this.getCookies);
  },
  computed: {
    fullName() {
      if (window.innerWidth > 800 && this.accountType == "individual") {
        return this.firstName + " " + this.lastName;
      } else if (window.innerWidth > !800 && this.accountType == "individual") {
        const firstInitial = this.firstName[0];
        const lastInitial = this.lastName[0];
        firstInitial + "." + lastInitial;
      }
      if (window.innerWidth > 800 && this.accountType == "organisation") {
        return this.firstName;
      } else {
        const firstInitial = this.firstName[0];
        return firstInitial;
      }
    },
    ...mapGetters(["getPassportfile"]),
    profileImageSrc(){
      return this.getPassportFile ? this.getPassportFile : require("@/assets/profileImage.jpg");
    },
    
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.mobileShow = false;
        this.showDropDown = false;
      }
    },

    // userTypeSelect(newValue) {
    //   if (newValue) {
    //     this.sidebarTogleNav(newValue);
    //   }
    // }

  },
  methods: {
    smartConfigur() {
      partners.smartConfiguration(this.user.id).then(res => {
        this.configg = res;
      }).catch((err) => {
        console.log(err);
      })

    },
    saveClickType(tab) {
        localStorage.setItem("managementType", tab);
    },
    sidebarTogleNav(type) {
      if (type == "partner") {
        if (this.$route.path != "/user/partner/dashboard") {
          this.$router.push("/user/partner/dashboard");
        }
      } 
      if (type != "partner") {
        if (this.$route.path != "/user/dashboard") {
          this.$router.push("/user/dashboard");
        }
      }
    },
    focusSearch() {
      const search = document.getElementById("search");
      search.focus();
    },
    editProfile() {
      this.$router.push("/user/account");
    },
    settingsProfile() {
      this.$router.push("/user/profile-settings");
    },
    resetPassword() {
      this.$router.push("/password-reset");
    },
    logout() {
      this.$store.dispatch("clearUser");
      this.$store.dispatch("setAuthentication", false);
      localStorage.clear();
      localStorage.removeItem("smartUser");
      // document.cookie = "shelta-c; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.$cookies.remove('shelta-c', '/', 'myshelta.com');
      this.$router.push("/");
      // location.reload();
    },
    fetchUserOptions() {
      partners.userCheck(this.user.id).then(res => {
        // console.log("res", res)
        this.checkUser = res;
        // this.userPlans = res.plan.smart_plan_id;
        // if (this.checkUser.show_partner_button == 'YES' && (this.userPlans == '4' || this.userPlans == '5')) {
        //   this.userTypeSelect = "partner";

        // }
        if (res.plan != null) {
          this.userPlans = res.plan.smart_plan_id;
          if (this.checkUser.show_partner_button == 'YES' && (this.userPlans == '4' || this.userPlans == '5')) {
            this.userTypeSelect = "partner";

          }
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    requestCountNumber() {
      partners.requestCount(this.user.id).then(res => {
        // console.log("Count", res);
        this.requestNumber = res.fm_io_request + res.inspection_request + res.maintenance_request + res.management_request;
      }).catch((err) => {
        console.log(err);
      })
    },
    
  },
  created() {
    const user = this.$store.getters.getUser;
    this.subscription = this.$store.getters.getSubscription;
    this.firstName = user.firstname;
    this.lastName = user.lastname;
    this.userCode = user.usercode;
    this.accountType = user.accounttype;
  },
};
</script>

<style scoped lang="scss">
/* page structure */

.type-select {
  border: none;
  font-family: Lato;
  font-weight: 500;
  font-size: 14px;
  color: #555C74;
  box-shadow: none;
  outline: 0;
  cursor: pointer;
}

.profile-image{
 border-radius: 60px;
 border: 2px solid #b1b2b2;
}
.sidebar-layout {
  min-height: 100vh;
  display: flex;
  position: relative;
  background: #f5f5f5;
}

.verified-active {
  margin-bottom: 0 !important;
  justify-content: center;
  color: #555C74 !important;
}

.subscribe-toggle {
  margin-bottom: 40px !important;
  margin-top: 0 !important;
  // background: rgba(255, 255, 255, 0.8);
  background: #eaeaea;
  border-radius: 50px !important;
  padding: 0 !important;
  height: 37px;
  position: relative;
}

.subscribed {
  background: #3ec250;
  padding: 8px 0px;
  border-radius: 50px;
  margin-bottom: 0 !important;
  padding: 8px 16px;
  height: 37px;
  position: relative;
  position: absolute;
  left: 0;
}

.notsubscribed {
  background: #eb0000;
  padding: 8px 0px;
  border-radius: 50px;
  margin-bottom: 0 !important;
  padding: 8px 16px;
  position: absolute;
  right: 0;
}

.nav-container::-webkit-scrollbar {
  display: none;
  /* Hide scrollbar for Chrome, Safari and Opera */

  /* Hide scrollbar for IE, Edge and Firefox */
}
// .nav-container {
//   background: #ffffff;
// }
.nav {
  display: flex;
  flex-direction: column;
}

.nav-item {
  display: flex;
  align-items: center;
  text-decoration: none;
  // color: #fff;
  color: #555C74;
  padding: 10px;
  // border-radius: 20px;
  border-radius: 4px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.nav-list {
  list-style-type: none;
  padding: 0;
}

.nav-item:hover {
  background-color: #f0f0f0;
}

.icon {
  margin-right: 10px;
}

.text {
  font-size: 14px;
}

.logo-blue {
  width: 50%;
  margin-left: 1rem;
  max-width: 100px;
}

.logo-blue img {
  width: 100%;
  vertical-align: middle;
}

.sidebar-nav {
  min-width: 215px;
  // background-image: linear-gradient(180deg, #0033ea 41.75%, #000000 119.38%);
  background: #ffffff;
  box-shadow: 5px 0px 4px rgba(0, 0, 0, 0.05);
  min-height: 100vh;
  height: 100%; // Newlly added css to boost the sidebar height
  position: fixed;
  // z-index: 5;
  z-index: 110;

  /* this prevent promo link background image from overflowing */
  // overflow: hidden;
  overflow-y: scroll;
}

.main-page {
  width: calc(100% - 215px);
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: 238px;
  margin-bottom: 3rem;
}

.header-navbar {
  height: 96px;
  background: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
  padding: 0 50px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
}

.dropdown-icon{
  margin-left: 8px;
}

.page-content {
  flex-grow: 1;
  background: #f5f5f5;
  color: #000;
  padding: 30px;
  justify-content: flex-start;
  margin: 15px;
}

@media (max-width: 991.98px) {
  .sidebar-nav {
    min-width: 190px;
  }

  .main-page {
    width: calc(100% - 190px);
    margin-left: 238px;
  }

  .header-navbar {
    padding: 0 20px;
  }

  .page-content {
    padding: 0px 20px 30px;
  }
}

@media (max-width: 767.98px) {
  .header-navbar {
    height: 70px;
  }

  .sidebar-nav {
    left: -100%;
    transition: all 0.5s;
  }

  .sidebar-nav.showSidebar {
    left: 0;
  }

  .main-page {
    width: 100%;
    margin-left: 0;
  }
}

/* end of page structure */

/* sidebar nav element styling */
.sidebar-nav .logo-image {
  // height: 96px;
  height: 66px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #ffffff;
  margin-bottom: 30px;
  position: sticky;
  top: 0;
  z-index: 200;
  background: #ffffff;
  // background: #0033ea;
}

.mobile-close-sidebar {
  display: none;
  border: 0;
  color: #fff;
  background: transparent;
  padding: 0 5px 5px;
  line-height: 1;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-family: "Gotham-Book";
  top: 10px;
  right: 10px;
  font-size: 22px;
}

.sidebar-nav .nav-items {
  padding: 0 10px;
}

.nav-items >* {
  display: flex;
  // align-items: center;
  padding: 6px 13px;
  min-width: 168px;
  max-width: fit-content;
  margin: 20px auto;
  border-radius: 4px;
  text-decoration: none;
  color: #fff;
  // color: #555C74;
  font-size: 14px;
}
// .nav-items {
//   display: flex;
//   align-items: center;
//   padding: 6px 13px;
//   min-width: 168px;
//   max-width: fit-content;
//   margin: 20px auto;
//   border-radius: 4px;
//   text-decoration: none;
//   color: #fff;
//   // color: #555C74;
//   font-size: 14px;
// }

.nav-items .long-text {
  padding: 6px 10px;
}

.nav-top-verified {
  align-items: center;
  padding: 6px 13px;
  min-width: 168px;
  max-width: fit-content;
  margin: 20px auto;
  color: #fff;
  // color: #555C74;
  font-size: 14px;
}

// .nav-items a:hover,
// .nav-items a:focus,
// .nav-items a.router-link-active {
//   background: rgba(255, 255, 255, 0.8);
//   color: var(--primary-color);
//   // color: #555C74;
//   font-weight: 600;
// }

.nav-items a:hover,
.nav-items a:focus,
.nav-items a.router-link-active {
  background: var(--primary-color);
  color: #ffffff;
  font-weight: 600;
  text-decoration: none;
}

.logout-sidebar {
  cursor: pointer;
  .text {
    padding-left: 6px;
  }
}
.logout-sidebar:hover,
.logout-sidebar:focus {
  // background: none;
  // color: inherit;

  background: var(--primary-color);
  color: #ffffff;
  font-weight: 600;
  text-decoration: none;
  
}

.nav-items a svg {
  margin-right: 10px;
}

.nav-items .long-text svg {
  margin-right: 8px;
}

a .primary-fill {
  // fill: #fff;
  fill: #555C74;
}

a .primary-light-fill {
  fill: rgba(255, 255, 255, 0.8);
  // fill: #555C74;
}

a .secondary-fill {
  fill: var(--primary-color);
}

a:hover .primary-fill,
a:focus .primary-fill,
a.router-link-active .primary-fill {
  fill: #fff;
}

a:hover .primary-light-fill,
a:focus .primary-light-fill,
a.router-link-active .primary-light-fill {
  fill: rgba(var(--primary-rgb), 0.5);
}

a:hover .secondary-fill,
a:focus .secondary-fill,
a.router-link-active .secondary-fill {
  fill: #fff;
  // fill: #555C74;
}

#promo-banner {
  background-color: rgba(47, 198, 67, 1);
  border-radius: 0;
  position: sticky;
  color: #fff;
  box-shadow: 0 0 0 100vw rgba(47, 198, 67, 1);
  clip-path: inset(0 -100vw);
  overflow: hidden;
}

#promo-banner:hover {
  background-color: rgba(47, 198, 67, 1);
  color: #fff;
}

@media (max-width: 767.98px) {
  .sidebar-nav .logo-image {
    height: 70px;
    justify-content: flex-start;
    padding-left: 30px;
  }

  .logo-image img {
    width: 70px;
  }

  .mobile-close-sidebar {
    display: flex;
  }
}

/* end of element styling */

/* header navbar element styling */
.header-navbar .toggle-sidebar {
  display: none;
  background: none;
  border: 0;
  padding: 5px;
}

.header-navbar .search-container {
  width: fit-content;
  height: 40px;
  position: relative;
}

.search-container input {
  background: #f5f5f5;
  width: 258px;
  height: 100%;
  border: 0;
  border-radius: 20px;
  padding: 0 10px 0 43px;
  color: #000;
  font-family: "Gotham-Book";
  font-weight: 500;
}

.search-container input:focus {
  outline: none;
  border: 2px solid lightblue;
}

.search-container input::placeholder {
  color: #000;
  font-family: "Gotham-Book";
  font-weight: 500;
  font-size: 13px;
}

.search-container input::-moz-placeholder {
  color: #000;
  font-family: "Gotham-Book";
  font-weight: 500;
  font-size: 13px;
  opacity: 1;
}

.search-container input::-webkit-input-placeholder {
  color: #000;
  font-family: "Gotham-Book";
  font-weight: 500;
  font-size: 13px;
}

.search-container input::-ms-input-placeholder {
  color: #000;
  font-family: "Gotham-Book";
  font-weight: 500;
  font-size: 13px;
  opacity: 1;
}

.search-container img {
  position: absolute;
  left: 16px;
  top: 10px;
}

.user-nav-links {
  display: flex;
  align-items: center;
  position: relative;
}

.user-nav-links .nav-link {
  color: #000;
  font-family: "Gotham-Book";
  font-weight: 700;
  font-size: 14px;
  margin-right: 35px;
  text-transform: capitalize;
  background: transparent;
  cursor: pointer;
  min-width: fit-content;
}

.user-nav-links .nav-link:last-of-type {
  margin-right: 0;
}

.user-nav-links .nav-link:hover,
.user-nav-links .nav-link:focus {
  color: var(--primary-color);
}

.user-nav-links .nav-link+.dropdown {
  display: block;
  background: transparent;
  position: absolute;
  width: 200px;
  height: fit-content;
  /* top: 230%; */
  top: 95%;
  /* left: -29%; */
  right: 20px;
  z-index: 3;
}

.dropdown .arrow {
  display: inline-block;
  border-color: transparent transparent #fff transparent;
  border-style: solid;
  border-width: 10px;
  margin-bottom: -3px;
  margin-left: 80%;
}

.dropdown .dropdown-links {
  background: #fff;
  padding: 7px 0;
  box-shadow: 4px 10px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.dropdown .dropdown-link {
  background: #fff;
  height: 32px;
  width: 100%;
  color: #555C74;
  display: flex;
  align-items: center;
  padding-left: 26px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 12px;
  line-height: 1;
  font-family: "Gotham-Book";
}

.dropdown .dropdown-link:last-of-type {
  border-bottom: 0;
}

.dropdown-link img {
  margin-right: 22px;
}

.dropdown .dropdown-link:hover {
  background: #f5f5f5;
}

.notification-border{
  background: #F4F7FF;
  border: 1px solid #E7E7E7;
  border-radius: 6px;
  width: 50px;
  height: 50px;
  
  padding-bottom: 0px;
    padding-top: 4px;

}

.notification-counter {
  font-weight: 50;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: red;
  color: #fff;
  font-size: 5px;
  line-height: 5px;
  height: 6px;
  width: 6px;
  vertical-align: top;
  margin-top: -19px;
  margin-left: 6px;
  
}

.user-welcome-message {
  display: none;
}


.profile-container {
  display: flex;
  align-items: flex-start;
  background: #f9f9f9;
  padding: 15px;
  border-radius: 10px;
  // max-width: 400px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}

.profile-pic {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  // margin-right: 15px;
  margin-right: 8px;
}

.profile-info {
  flex: 1;
}

.profile-info h3 {
  margin: 0;
  font-size: 14px;
  font-family: Lato;
  color: #555C74;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 136px;
}

.profile-info p {
  margin: 3px 0;
  font-size: 12px;
  color: #555C74;
  font-family: Lato;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 136px;
}

.requestCount {
  background: #dddddd;
  padding: 4px 4px;
  border-radius: 4px;
  color: #000;
}

// .nav {
//   position: relative;
// }
// .profile-bottom {
//   position: fixed;
//   bottom: 0;
// }

@media (min-width: 414px) {
  .user-welcome-message {
    display: block;
  }
}

@media (min-width: 768px) {
  .header-navbar {
    justify-content: flex-end;
    position: static;
  }

  .logo-blue {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .user-nav-links .nav-link {
    margin-right: 20px;
  }

  .user-nav-links .nav-link+.dropdown {
    right: 40px;
  }
}

@media (max-width: 767.98px) {
  .header-navbar .toggle-sidebar {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .user-nav-links .nav-link+.dropdown {
    /* top: 180%; */
    top: 100%;
  }

  .search-container input {
    width: 220px;
  }
}

@media (max-width: 575.98px) {
  .user-nav-links .nav-link {
    margin-right: 10px;
  }
  .page-content {
    margin: 0;
  }

  .header-navbar .search-container {
    position: absolute;
    left: 65px;
  }

  .search-container input {
    width: 40px;
    transition: all 0.5s;
  }

  .search-container input:focus {
    width: 220px;
  }
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
</style>
